<template>
  <div>
    <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100vh">
      <b-card-img
        src="/static_img/logos/QESG_vertical.png"
        alt="Image"
        class="mb-5"
        style="max-height: 30vh; max-width: 30vh"
      />

      <h4>문제가 발생했습니다. 관리자에게 문의해주세요.</h4>
      <h5 class="mb-5">문의: info@qesg.co.kr</h5>
      <b-button variant="outline-info" @click="$router.push('/')">
        <b-icon icon="house-door" class="mr-1" />
        메인으로 돌아가기
      </b-button>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue';
import Footer from '@/components/Footer';
export default {
  name: 'Error',
  components: {
    Header,
    Footer
  }
};
</script>

<style></style>
